import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { endpoints, asset } from "@/lib/api";
import { CTASection } from "@/components/site/Bits";
import { LineReveal, Reveal } from "@/lib/motion";

export default function JournalDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    endpoints.journalPost(slug).then((d) => {
      setPost(d);
      document.title = `${d.title} — ARIA Journal`;
    }).catch(() => {});
  }, [slug]);

  if (!post) return <div className="h-screen" />;

  const paragraphs = (post.body || "").split("\n").filter(Boolean);

  return (
    <div data-testid="journal-detail">
      <header className="aria-container pt-40 pb-14 md:pt-52 md:pb-20">
        <Link to="/journal" className="aria-link text-[0.7rem] uppercase tracking-[0.22em] text-aria-muted">← The Journal</Link>
        <div className="mt-10 text-[0.72rem] uppercase tracking-[0.24em] text-aria-brass">{post.category} · {post.read_time}</div>
        <h1 className="mt-6 max-w-4xl font-display text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-aria-ink">
          <LineReveal lines={[post.title]} />
        </h1>
      </header>

      <div className="aria-container pb-16">
        <div className="aspect-[16/9] w-full overflow-hidden">
          <img src={asset(post.cover_image)} alt={post.title} className="h-full w-full object-cover" />
        </div>
      </div>

      <article className="aria-container pb-28 md:pb-40">
        <div className="mx-auto max-w-2xl">
          {paragraphs.map((p, i) => (
            <Reveal key={i}>
              <p className={`font-light leading-[1.9] text-aria-cocoa/85 ${i === 0 ? "text-xl md:text-2xl" : "text-lg"} mt-8 first:mt-0`}>
                {p}
              </p>
            </Reveal>
          ))}
          <div className="mt-16 border-t border-aria-travertine pt-8 text-[0.7rem] uppercase tracking-[0.22em] text-aria-muted">
            Written by {post.author}
          </div>
        </div>
      </article>

      <CTASection />
    </div>
  );
}
